module.exports = __webpack_public_path__ + "static/media/ecosentino.7cd376e6.svg";